module.exports = __webpack_public_path__ + "img/pricing.2ac66262.jpg";